import { Loading } from "@app/components";
import { useUser } from "@services/servicesGenericsTables";
import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

export default function UsersLayout() {
  const [loading, setLoading] = useState(true);
  const fetched = useRef(false);
  const { fetchAll: fetchAllUser } = useUser();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      setLoading(true);

      Promise.all([fetchAllUser()])
        .then(() => setLoading(false))
        .catch((error) => {
          setLoading(false);
        });
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
